import { render } from "./DataSciencePage.vue?vue&type=template&id=54a06b54&scoped=true"
import script from "./DataSciencePage.vue?vue&type=script&lang=js"
export * from "./DataSciencePage.vue?vue&type=script&lang=js"

import "./DataSciencePage.vue?vue&type=style&index=0&id=54a06b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a06b54"]])

export default __exports__